
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { Icon } from "vant";
import { useRoute, useRouter } from "vue-router";
import { getCookieMac } from "@/utils/cookies";

export default defineComponent({
  props: {
    color: {
      type: String,
      default: () => "#fff",
    },
    metaObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // title: {
    //   type: String,
    //   default: () => "",
    // },
  },
  components: {
    VanIcon: Icon,
  },
  setup(props) {
    const router = useRouter();
    const route: any = useRoute();
    const proxyData = reactive({
      route: route,
      goBack() {
        if (route.meta.toName) {
          router.push({ name: route.meta.toName });
        } else {
          router.go(-1);
        }
      },
      goLogin() {
        let mac: any = getCookieMac();
        router.push({
          name: "home",
          query: { mac: mac, type: "logoOut" },
        });
      },
    });
    onMounted(() => {
      console.log(props);
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
